import secureLocalStorage from "react-secure-storage";
import "../components/landingComponents/Coin.css";
import { useEffect, useState } from "react";

const StripeCoin = () => {
  const [role, setRole] = useState("");

  useEffect(() => {
    const userRole = secureLocalStorage.getItem("role");
    setRole(userRole);
  }, []);
  return (
    <>
      <div className="leftFrame">
        <img className="dollar-1-icon" alt="" src="/dollar.png" />
        <img className="euro-2-icon" alt="" src="/euro.png" />
      </div>
      <div className="rightFrame">
        <img className="pond-1-icon" alt="" src="/pond.png" />
      </div>
    </>
  );
};

export default StripeCoin;
